// EPI Service Request 文档回收站弹窗
// 由 SectionFunction/ServiceRequest.js 的 showServiceRequestRecycleBin 动态挂载
// 列出该服务项下已删除(回收站)的文档，勾选后可批量还原；还原成功通知父级刷新 Files 列
import React from 'react';
import moment from 'moment';
import { Table, Button, message } from 'antd';
import AntDraggableModal from 'components/AntDraggableModal';
import { httpClient } from 'util/Api';
import { config } from 'util/config';
import * as globalFunction from 'util/GlobalFunction';

export default class ServiceRequestRecycleBinModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      list: [],
      loading: false,
      selectedRowKeys: [],     // 选中的 service_request_document id
      submitting: false,
    };
  }

  componentDidMount() {
    this.loadList();
  }

  loadList = () => {
    let that = this;
    this.setState({ loading: true });
    httpClient.get('/Business/ServiceRequest/GetDeletedDocumentList?serviceRequestId=' + this.props.serviceRequestId)
      .then(({ data }) => {
        if (data.result) {
          that.setState({ list: data.data || [], loading: false, selectedRowKeys: [] });
        } else {
          message.error(data.message || 'Failed to load deleted documents.');
          that.setState({ loading: false });
        }
      })
      .catch(() => {
        message.error('Failed to load deleted documents.');
        that.setState({ loading: false });
      });
  };

  onRestore = () => {
    if (this.state.selectedRowKeys.length === 0) {
      message.warning('Please select at least one document to restore.');
      return;
    }
    let that = this;
    this.setState({ submitting: true });
    httpClient.post('/Business/ServiceRequest/RestoreDocuments', this.state.selectedRowKeys)
      .then(({ data }) => {
        if (data.result) {
          message.success('Restored.');
          // 通知父级刷新（还原的文档重新出现在 Files 列）
          if (that.props.onRestored) that.props.onRestored();
          // 刷新回收站列表（被还原的从列表消失）
          that.setState({ submitting: false, open: false }, that.loadList);
        } else {
          message.error(data.message || 'Restore failed.');
          that.setState({ submitting: false });
        }
      })
      .catch(() => {
        message.error('Restore failed.');
        that.setState({ submitting: false });
      });
  };

  close = () => {
    this.setState({ open: false });
    setTimeout(() => { this.props.onClose && this.props.onClose(); }, 200);
  };

  render() {
    const columns = [
      {
        // 点文件名打开/下载文档（与 Files 列、Document section 回收站一致，走 /Business/Document/Download/{DocumentId}）
        title: 'Name', dataIndex: 'DocumentName', ellipsis: true,
        render: (value, record) => (
          <span
            className="link"
            style={{ cursor: 'pointer' }}
            onClick={() => globalFunction.download({ url: '/Business/Document/Download/' + record.DocumentId + '?filename=' + globalFunction.formatFileNameForUrl(value), data: null, filename: value })}
          >{value}</span>
        ),
      },
      {
        title: 'Size', dataIndex: 'DocumentSize', width: 100,
        render: (v) => globalFunction.formatFileSize(v),
      },
      { title: 'Deleted By', dataIndex: 'DocumentDeletedBy', width: 150 },
      {
        title: 'Date Deleted', dataIndex: 'DocumentDateDeleted', width: 160,
        render: (v) => v ? moment(v).format('DD/MM/YYYY HH:mm') : '',
      },
    ];

    return (
      <AntDraggableModal
        title="Recycle Bin"
        open={this.state.open}
        onCancel={this.close}
        width={1200}
        maskClosable={config.component.Modal.maskClosable}
        footer={[
          <Button key="close" onClick={this.close} size={config.component.size}>Close</Button>,
          <Button
            key="restore"
            type="primary"
            loading={this.state.submitting}
            disabled={this.state.selectedRowKeys.length === 0}
            onClick={this.onRestore}
            size={config.component.size}
          >
            Restore
          </Button>,
        ]}
      >
        <Table
          bordered
          size="small"
          rowKey={(r) => r.key}
          rowSelection={{
            selectedRowKeys: this.state.selectedRowKeys,
            onChange: (keys) => this.setState({ selectedRowKeys: keys }),
          }}
          columns={columns}
          dataSource={this.state.list}
          loading={this.state.loading}
          pagination={false}
          scroll={config.component.Table.scroll}
          locale={{ emptyText: 'No deleted documents.' }}
        />
      </AntDraggableModal>
    );
  }
}
